import { Query } from '@domain/graphql.types';
import { QueryCourierToken } from '@infrastructure/graphql';
import { useQuery } from 'urql';

const useCourierTokenQuery = ({ pause }: { pause?: boolean } = {}) => {
  const [result, reexecuteQuery] = useQuery<Pick<Query, 'courierToken'>, void>({
    query: QueryCourierToken,
    pause,
    requestPolicy: 'network-only',
  });

  const { data, fetching, error } = result;

  return {
    data,
    fetching,
    error,
    reexecuteQuery,
  };
};

export default useCourierTokenQuery;
